import React, { ReactNode } from "react";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import { useQuickBooksDataRange } from "../../hooks/useQuickBooksDataRange";

interface QuickBooksDataRangeGateProps {
  children: (earliestMonth: string) => ReactNode;
}

export const QuickBooksDataRangeGate: React.FC<
  QuickBooksDataRangeGateProps
> = ({ children }) => {
  const { loading, earliestMonth } = useQuickBooksDataRange();

  if (loading) {
    return <LoadingIndicator isFullScreen={false} />;
  }

  if (earliestMonth === null) {
    return (
      <div className="text-center py-8 text-gray-500 dark:text-gray-400">
        QuickBooks P&amp;L data is not available at this time.
      </div>
    );
  }

  return <>{children(earliestMonth)}</>;
};
